<template>
  <b-nav
    v-if="menuContent"
    :class="menuDirection"
    class="navigation"
  >
    <template v-for="list in menuContent">
      <template v-for="(item, index) in list">
        <template v-if="item.linkActive">
          <template v-if="item.columns && item.columns.length">

            <transition
              :key="index"
              name="slide-fade"
            >
              <b-nav-item-dropdown
                :text="item.linkText"
                :key="index"
                :class="{ 'mega-menu': item.linkMegaMenu }"
                :title="item.linkTitle"
                right
              >

                <template
                  v-for="(subItem, subIndex) in item.columns"
                  v-if="subItem.linkActive"
                  :title="item.linkTitle"
                >
                  <template v-if="subItem.columns">
                    <ul
                      :key="subIndex"
                      :class="{floated: menuDirection === 'horizontal'}"
                      class="menu-columns"
                    >
                      <h3>{{ subItem.linkText }}</h3>
                      <generic-menu-link
                        v-for="(subSubItem, subSubIndex) in subItem.columns"
                        v-if="subSubItem.linkActive"
                        :key="subSubIndex"
                        :href="subSubItem.linkUrl"
                        :target="subSubItem.linkTarget"
                        :class="'btn-' + subSubItem.linkCallToAction"
                        :title="subSubItem.linkTitle"
                        nav-type="b-dropdown-item"
                      >
                        {{ subSubItem.linkText }}
                      </generic-menu-link>
                    </ul>
                  </template>
                  <template v-else>
                    <generic-menu-link
                      :key="subIndex"
                      :href="subItem.linkUrl"
                      :class="['single-link btn-' + subItem.linkCallToAction]"
                      :target="subItem.linkTarget"
                      :title="subItem.linkTitle"
                      nav-type="b-dropdown-item"
                    >
                      {{ subItem.linkText }}

                    </generic-menu-link>
                  </template>
                </template>

              </b-nav-item-dropdown>
            </transition>
          </template>

          <template v-else>
            <generic-menu-link
              :key="index"
              :href="item.linkUrl"
              :class="'btn-' + item.linkCallToAction"
              :target="item.linkTarget"
              :title="item.linkTitle"
            >
              {{ item.linkText }}
            </generic-menu-link>
          </template>
        </template>
      </template>
    </template>
  </b-nav>
</template>

<script>
import GenericMenuLink from './generic-menu-link'

export default {
  components: {
    GenericMenuLink
  },
  props: {
    menuContent: {
      type: Object,
      required: true
    },
    menuDirection: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "~@scss/custom.scss";

//content sidebar max with, only if sidebar has content, we contain it to a max width of this
.page-content-menu-sidebar {
  padding: 0em;
  @include media-breakpoint-up(lg) {
    max-width: 25%;
    padding: 0em;
  }
  .container {
    @include media-breakpoint-down(md) {
      padding: 0em;
    }
  }
  .navigation {
    &.nav {
      &.vertical {
        display: flex;
        flex-grow: 1;
        ul,
        li {
          width: 100%;
        }
      }
    }
  }
  &.has-content {
    width: 100%;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.navigation {
  &.nav {
    &.vertical {
      display: block;
      margin-bottom: 1.5rem;
      overflow: hidden;
      position: relative;

      .nav-item {
        float: none;
        a {
          padding: 0.75rem 0rem;
          display: block;
          word-wrap: break-word;
        }
        &.mega-menu {
          .dropdown-menu {
            min-width: auto;
          }
        }
        .dropdown-menu {
          position: relative !important;
          transform: none !important;
          background: transparent;
          min-width: auto;
          box-shadow: none;
          float: none;
          &.show {
            display: block;
          }
          .nav-item {
            a {
              padding: 0.5rem 1rem 0.5rem 1.5rem;
            }
          }
        }
      }
      .nav-link.active {
        text-decoration: underline;
      }
    }
    .nav-item {
      float: left;
      a {
      }
      h3 {
      }
      li.nav-item {
        width: 100%;
      }
      .dropdown-menu {
        background: var(--main-primary);
        border-radius: 0;
        box-shadow: 17px 17px 17px rgba(0, 0, 0, 0.15);
        border: 0;
        margin-top: -1px;

        ul {
          &:hover {
            background: transparent;

            li {
              background: transparent;

              &:hover {
                a {
                  color: var(--main-secondary);

                  &:hover {
                  }
                }
              }
            }
          }
        }
      }
      &.mega-menu {
        .dropdown-menu {
          min-width: 700px;
          ul {
            &.floated {
              float: left;
              width: 33%;
              padding: 1rem 2rem;
              a:hover {
                background: transparent;
              }
              .nav-item {
                margin-left: 0rem;
                padding-left: 0rem;
                a {
                  padding: 0.5rem;
                  &.btn-primary {
                    color: #fff;
                    display: block;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
